import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-gold/15 bg-[#08090C] noise-overlay" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <LogoMark className="w-12 h-12 text-gold" />
            <div>
              <div className="font-display font-bold text-lg uppercase tracking-[0.12em] text-parchment">Crusaders of the Cross</div>
              <div className="font-mono text-xs tracking-[0.3em] text-gold uppercase mt-1">Shield of Faith &bull; Iron of Discipline</div>
            </div>
          </div>
          <p className="mt-6 text-sm text-stone-400 leading-relaxed max-w-md font-serif italic text-base">
            &ldquo;Blessed be the Lord my Rock, who trains my hands for war, and my fingers for battle.&rdquo;
            <span className="block mt-2 font-mono not-italic text-xs tracking-[0.25em] text-gold">— PSALM 144:1</span>
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Navigate</div>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-store-link" to="/store" className="text-stone-400 hover:text-gold transition-colors">Club Store</Link></li>
            <li><Link data-testid="footer-about-link" to="/about" className="text-stone-400 hover:text-gold transition-colors">Our Mission</Link></li>
            <li><Link data-testid="footer-donate-link" to="/donate" className="text-stone-400 hover:text-gold transition-colors">Sponsorship &amp; Giving</Link></li>
            <li><Link data-testid="footer-bylaws-link" to="/bylaws" className="text-stone-400 hover:text-gold transition-colors">Bylaws of the Order</Link></li>
            <li><Link data-testid="footer-join-link" to="/join" className="text-stone-400 hover:text-gold transition-colors">Join the Order</Link></li>
            <li><Link data-testid="footer-members-link" to="/members" className="text-stone-400 hover:text-gold transition-colors">Members HQ</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="eyebrow mb-5">Headquarters</div>
          <p className="font-mono text-xs text-stone-500 tracking-widest">LAT 34.0522 N &nbsp;/&nbsp; LON 118.2437 W</p>
        </div>
      </div>
      <div className="border-t border-gold/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 font-mono text-xs text-stone-500 tracking-widest uppercase">
          <span data-testid="footer-copyright">&copy; {new Date().getFullYear()} Crusaders of the Cross</span>
          <span>Safety &bull; Stewardship &bull; Scripture</span>
        </div>
      </div>
    </footer>
  );
}
